import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ArticlesSection() {
  const { t } = useTranslation();

  const articles = [
    {
      label: t('articles.mainLabel'),
      title: t('articles.mainTitle'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20dual%20monitors%20displaying%20colorful%20spreadsheet%20data%2C%20clean%20white%20desk%20with%20ergonomic%20setup%2C%20warm%20afternoon%20sunlight%20through%20large%20windows%2C%20productivity%20focused%20atmosphere%2C%20editorial%20tech%20photography%2C%20organized%20minimalist%20desk%20with%20plants%20and%20notebook%2C%20professional%20creative%20environment&width=800&height=600&seq=art-main-v2&orientation=landscape',
      featured: true,
    },
    {
      label: t('articles.article1Label'),
      title: t('articles.article1Title'),
      link: '/artykul/jak-czytac-zdjecia-qc-kakobuy',
      imageUrl: 'https://readdy.ai/api/search-image?query=Closeup%20inspection%20of%20premium%20product%20details%20with%20magnifying%20glass%20on%20clean%20white%20surface%2C%20quality%20control%20photography%20scene%2C%20bright%20neutral%20studio%20lighting%2C%20sharp%20focus%20on%20fabric%20texture%20and%20stitching%2C%20professional%20product%20examination%20aesthetic%2C%20meticulous%20attention%20to%20detail&width=800&height=600&seq=art-qc-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article2Label'),
      title: t('articles.article2Title'),
      link: '/artykul/kakobuy-vs-pandabuy-porownanie',
      imageUrl: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20on%20marble%20table%20displaying%20different%20shopping%20apps%2C%20split%20comparison%20concept%2C%20modern%20clean%20setting%20with%20warm%20ambient%20light%2C%20tech%20comparison%20photography%2C%20elegant%20minimalist%20composition%2C%20neutral%20grey%20and%20warm%20gold%20tones&width=800&height=600&seq=art-vspanda-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article3Label'),
      title: t('articles.article3Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Top%20ten%20ranking%20display%20with%20trophy%20and%20fashion%20items%20on%20sleek%20dark%20surface%2C%20golden%20award%20elements%2C%20dramatic%20spotlight%20lighting%2C%20premium%20celebration%20aesthetic%2C%20luxury%20product%20showcase%20photography%2C%20elegant%20composition%20with%20numbered%20cards&width=800&height=600&seq=art-finds-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article4Label'),
      title: t('articles.article4Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=World%20map%20focused%20on%20Europe%20with%20Poland%20highlighted%2C%20shipping%20boxes%20and%20packages%20arranged%20around%20it%20on%20wooden%20desk%2C%20global%20logistics%20concept%2C%20warm%20natural%20lighting%2C%20international%20ecommerce%20photography%2C%20organized%20workspace%20with%20tracking%20documents%2C%20professional%20setting&width=800&height=600&seq=art-polska-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article5Label'),
      title: t('articles.article5Title'),
      link: '/artykul/kakobuy-vs-pandabuy-porownanie',
      imageUrl: 'https://readdy.ai/api/search-image?query=Scale%20balance%20with%20shopping%20bags%20on%20each%20side%20against%20soft%20gradient%20background%2C%20legal%20comparison%20concept%2C%20elegant%20minimalist%20composition%2C%20subtle%20gold%20and%20silver%20tones%2C%20symbolic%20justice%20and%20choice%20photography%2C%20clean%20modern%20aesthetic%20with%20gentle%20shadows&width=800&height=600&seq=art-vssuper-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article6Label'),
      title: t('articles.article6Title'),
      link: '/artykul/jak-czytac-zdjecia-qc-kakobuy',
      imageUrl: 'https://readdy.ai/api/search-image?query=Security%20shield%20icon%20with%20padlock%20and%20shopping%20cart%20on%20dark%20blue%20gradient%20background%2C%20cybersecurity%20concept%20photography%2C%20professional%20protection%20symbols%2C%20modern%20digital%20safety%20aesthetic%2C%20clean%20geometric%20composition%2C%20soft%20glowing%20highlights&width=800&height=600&seq=art-safe-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article7Label'),
      title: t('articles.article7Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20colorful%20trendy%20sneakers%20displayed%20on%20wooden%20shelves%20in%20bright%20modern%20room%2C%20sneakerhead%20display%20photography%2C%20natural%20light%20from%20large%20windows%2C%20organized%20shoe%20collection%20aesthetic%2C%20vibrant%20colors%20against%20warm%20wood%2C%20contemporary%20interior%20design&width=800&height=600&seq=art-sneakers-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article8Label'),
      title: t('articles.article8Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20neatly%20with%20tracking%20labels%20and%20tape%2C%20logistics%20warehouse%20setting%20with%20conveyor%20belt%2C%20ecommerce%20fulfillment%20photography%2C%20organized%20industrial%20aesthetic%2C%20warm%20practical%20lighting%2C%20professional%20shipping%20and%20delivery%20scene&width=800&height=600&seq=art-shipping-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article9Label'),
      title: t('articles.article9Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20tutorial%20setup%20with%20smartphone%20showing%20app%20interface%20and%20notebook%20with%20handwritten%20tips%2C%20cozy%20home%20desk%20environment%2C%20warm%20ambient%20lamp%20light%2C%20learning%20and%20discovery%20concept%20photography%2C%20approachable%20modern%20aesthetic&width=800&height=600&seq=art-beginner-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article10Label'),
      title: t('articles.article10Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Urban%20streetwear%20fashion%20flat%20lay%20with%20oversized%20hoodies%20caps%20and%20sneakers%20on%20concrete%20floor%2C%20moody%20street%20lighting%2C%20contemporary%20youth%20culture%20photography%2C%20dark%20aesthetic%20with%20neon%20accents%2C%20authentic%20city%20atmosphere%2C%20editorial%20street%20style%20composition&width=800&height=600&seq=art-street-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article11Label'),
      title: t('articles.article11Title'),
      link: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
      imageUrl: 'https://readdy.ai/api/search-image?query=Hidden%20treasure%20chest%20partially%20open%20revealing%20glowing%20fashion%20items%20on%20dark%20mystical%20background%2C%20discovery%20concept%20photography%2C%20warm%20golden%20light%20emanating%20from%20within%2C%20magical%20find%20aesthetic%2C%20treasure%20hunt%20theme%2C%20enchanting%20composition%20with%20sparkle%20effects&width=800&height=600&seq=art-gems-v2&orientation=landscape',
      featured: false,
    },
    {
      label: t('articles.article12Label'),
      title: t('articles.article12Title'),
      link: '/artykul/kakobuy-vs-pandabuy-porownanie',
      imageUrl: 'https://readdy.ai/api/search-image?query=Decision%20crossroads%20with%20two%20diverging%20paths%20represented%20by%20shopping%20carts%20in%20different%20directions%2C%20conceptual%20choice%20photography%2C%20minimalist%20symbolic%20composition%2C%20soft%20natural%20lighting%2C%20business%20decision%20aesthetic%2C%20clean%20neutral%20background%20with%20subtle%20shadows&width=800&height=600&seq=art-agent-v2&orientation=landscape',
      featured: false,
    },
  ];

  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            {t('articles.label')}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('articles.title')}{' '}
            <span className="text-accent-600">{t('articles.highlight')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {articles.map((article, i) => (
            <Link
              key={i}
              to={article.link}
              className={`group block bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all hover:scale-[1.01] ${
                article.featured ? 'md:col-span-3 md:row-span-1' : ''
              }`}
            >
              {article.featured ? (
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="aspect-[4/3] md:aspect-auto overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6 md:p-8 flex flex-col justify-center">
                    <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 self-start">
                      {article.label}
                    </span>
                    <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-sm">{t('articles.readMore')}</p>
                  </div>
                </div>
              ) : (
                <>
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-2.5 py-1 rounded-full mb-2">
                      {article.label}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-xs">{t('articles.readMore')}</p>
                  </div>
                </>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}